// In development (REACT_APP_BACKEND_URL unset) requests use CRA proxy → no CORS.
// In production, set REACT_APP_BACKEND_URL to your deployed backend URL.
const API = process.env.REACT_APP_BACKEND_URL
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : "/api";

export default API;
